import React from 'react'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ProductNotifyOEM from '../../Product/ProductNotifyOEM';
const ProductGridBoxOEM = ({ itemin }) => {
    return (
        <>
            <div className="product-card product-card--layout--grid d-flex bg-white position-relative rounded">
                <div className="product-card__image">
                    <div className="image image--type--product">
                        <a href={`/oem-category/${itemin?.catSlug}/${itemin?.subCatSlug}/${itemin?.slug}`} className="image__body"><img alt="" className="image__tag" src={itemin?.image} /></a>
                    </div>
                </div>
                <div className="product-card__info mt-2">
                    <div className="product-card__meta d-none"><span className="product-card__meta-title">{itemin?.catLabel}</span></div>
                    <div className="product-card__name">
                        <a href={`/oem-category/${itemin?.catSlug}/${itemin?.subCatSlug}/${itemin?.slug}`} className='fw-bold f14'>{itemin?.name}</a>
                    </div>
                    <div className="product-card__desc">{itemin?.shortDescription && itemin?.shortDescription != '' ? <>{itemin?.shortDescription}</> : <></>}</div>
                    <div className='mt-2 ps-3 pe-3 text-truncate text-primary fw500 f12'>
                        {itemin?.manufacture?.name != '' ? <>Manufactured by : {itemin?.manufacture?.name}</> : <></>}
                    </div>
                </div>
                <div className="product-card__footer">
                    <div className="product-card__prices">
                        <div className="product-card__price product-card__price--current">
                            {itemin?.price && itemin?.price!='0.00' ? <>
                                <span className='btn btn-sm bglblue mb-1 mt-2 ps-2 pe-2 d-flex align-items-center f15 fw500'>
                                    <CurrencyRupeeIcon className='f14 fw-bold' />{itemin?.price}
                                </span>
                            </>
                                :<>
                                <ProductNotifyOEM category={itemin?.catLabel} subCatLabel={itemin?.subCatLabel} mId={itemin?.manufacture?.manufactureId} model={itemin?.name} form='listPage' />
                                 {/* <span className='btn btn-sm bglblue mb-1 mt-2 ps-2 pe-2 d-flex align-items-center f15 fw500'>
                                    Ask Price
                                </span> */}
                            </>}
                           
                        </div>
                    </div>
                    <a href={`/oem-category/${itemin?.catSlug}/${itemin?.subCatSlug}/${itemin?.slug}`} className='btn btn-sm BghiSecondary HoverBgRed addtocartbtn text-white mb-1 mt-2 ps-3 pe-3 '>
                        Details
                    </a>
                </div>
            </div>
        </>
    )
}

export default ProductGridBoxOEM